import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Navbar from '../components/navBar'; // Assuming you have a Navbar component

const Magazine = () => {
  const [magazines, setMagazines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMagazines = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/magazines`);
        setMagazines(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch magazines');
        setLoading(false);
      }
    };

    fetchMagazines();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="bg-gray-900 min-h-screen text-white">
      <Navbar />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 text-white">Magazines</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {magazines.map((magazine) => (
            <div key={magazine.id} className="border border-gray-700 rounded-lg p-4 shadow-md bg-gray-800">
              <h2 className="text-xl font-semibold mb-2 text-white">{magazine.bookName}</h2>
              <p className="text-gray-300 mb-4">{magazine.description}</p>
              <Link
                to={`/magazine-viewer/${magazine.id}`}
                className="text-blue-400 hover:text-blue-300"
              >
                Read Magazine
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Magazine;
